/**
 * WhatsApp is the live order channel — there is no checkout, and the contact
 * form does not submit anywhere yet. Every "Order Now" / "Inquire" CTA routes
 * here.
 *
 * The number lives in exactly one place. It was previously hardcoded into two
 * separate components, which is how a phone number quietly goes stale.
 */

export const WHATSAPP_NUMBER = '14372416287';

export const whatsappUrl = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

/** Generic enquiry, used by the navbar and the section-level CTAs. */
export const GENERAL_ORDER_MESSAGE =
  "Hi Maison Vael! I'm interested in ordering.";

/**
 * Product-specific enquiry. Pre-filling the scent name matters here: orders are
 * placed by message, so the customer naming the product themselves is the whole
 * transaction.
 */
export const productOrderMessage = (product) =>
  `Hi Maison Vael! I'd like to order ${product.name} — ${product.type}, ${product.size}, ` +
  `$${product.price} CAD.`;

/** Props every outbound WhatsApp link needs. */
export const whatsappLinkProps = (message) => ({
  href: whatsappUrl(message),
  target: '_blank',
  rel: 'noopener noreferrer',
});

/**
 * The contact form, as a WhatsApp message.
 *
 * The form used to discard every submission while telling the visitor "we'll be
 * in touch within 24 hours". Rather than stand up a backend to store enquiries
 * nobody reads, the form now composes them into the channel the business
 * already answers on.
 *
 * Optional fields are omitted rather than sent blank, so a short enquiry stays
 * short.
 */
export const enquiryMessage = ({ name, email, phone, scent, message }) => {
  const lines = ['Hi Maison Vael! I’d like to enquire.', ''];
  if (name?.trim()) lines.push(`Name: ${name.trim()}`);
  if (email?.trim()) lines.push(`Email: ${email.trim()}`);
  if (phone?.trim()) lines.push(`Phone: ${phone.trim()}`);
  if (scent?.trim()) lines.push(`Scent of interest: ${scent.trim()}`);
  if (message?.trim()) lines.push('', message.trim());
  return lines.join('\n');
};
